import styled from 'styled-components';

export const containerSx = {
  flexDirection: {
    xs: 'column',
    sm: 'row',
  },
  alignItems: {
    sm: 'center',
  },
  gap: 4,
  py: 2,
  px: 4,
};

export const itemSx = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
};

export const LevelLabel = styled.span`
  margin-top: 0.4rem;
  font-size: 1.2rem;
  color: ${(props) => props.theme.config.colors.primary};
  text-align: center;
`;

export const iconSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '24px',
};

export const labelWithBackgroundSx = {
  width: 'auto',
  minHeight: '24px',
  padding: '0.4rem 1.2rem',
  fontWeight: 'bold',
  lineHeight: '1.6rem',
};
